module.exports = "/assets/data/fbfb72db0511bddd7ed3a698a26ff2e7-SO20.data.json";